import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "formatAuthError"
})
export class FormatAuthErrorPipe implements PipeTransform {
    public transform(value: string): unknown {
        return (
            value
                ?.split("_")
                .map((x) => x.charAt(0).toUpperCase() + x.slice(1))
                .join(" ") || ""
        );
    }
}
